import { useTranslation } from 'react-i18next'
import { Button } from '../ui/button'

interface FormActionsProps {
  onSubmit?: () => void
  onCancel: () => void
  submitText: string
  isLoading: boolean
  className?: string
}

export function FormActions({
  onSubmit,
  onCancel,
  submitText,
  isLoading,
  className = '',
}: FormActionsProps) {
  const { t } = useTranslation()

  return (
    <div className={`flex items-center gap-3 pt-5 border-t border-neutral-100 ${className}`}>
      <Button
        type="submit"
        onClick={onSubmit ? () => onSubmit() : undefined}
        disabled={isLoading}
        loading={isLoading}
        variant="primary"
        size="lg"
      >
        {submitText}
      </Button>
      <Button type="button" onClick={onCancel} variant="secondary" size="lg">
        {t('common.cancel')}
      </Button>
    </div>
  )
}
